import {Component, Injector, OnDestroy, OnInit} from '@angular/core';
import {BaseDialogTemplateComponent} from '../base-dialog-template.component';

@Component({
  selector: 'ship-dialog-template',
  templateUrl: './ship-dialog-template.component.html',
  styleUrls: ['./ship-dialog-template.component.scss']
})
export class ShipDialogTemplateComponent extends BaseDialogTemplateComponent implements OnInit, OnDestroy {

  entity: any;
  positionEntity: any;
  shipEntity: any;
  engineEntity: any;
  ambientEntity: any;
  shipId: any;
  shipNo: any;
  location: any;
  shipRef: any;
  // keeps the active tab
  activeTab: string;
  isRedImage: any = false;
  isMotorError: any = false;
  relativeWindSpeed: any;
  relativeWindDirection: any;
  cloudHeight: any;
  rainfallAmount: any;
  seaWaterTemperature: any;
  temperature: any;
  humidity: any;
  radiation: any;
  currentDirection: any;
  currentIntensity: any;
  swell: any;
  salinity: any;
  distance: any;
  pressure: any;
  heading: any;
  rateOfTurn: any;
  courseOverGround: any;
  speedOverGround: any;
  speedThroughWater: any;
  depth: any;
  heave: any;
  heaveRate: any;
  roll: any;
  rollRate: any;
  status: any;
  shipStatus: string;
  locationShip: string[] = ['', ''];
  lastUpdatedTime: any;
  etcSpeedA1_1: any;
  etcSpeedA2_1: any;
  etcSpeedB1_1: any;
  etcSpeedB2_1: any;
  tLubeOil: any;
  tFuel: any;
  tCoolant: any;
  pCoolant: any;
  tExhaustA1: any;
  tExhaustA2: any;
  tExhaustA3: any;
  tExhaustA4: any;
  tExhaustA5: any;
  tExhaustA6: any;
  tExhaustA7: any;
  tExhaustA8: any;
  tExhaustB1: any;
  tExhaustB2: any;
  tExhaustB3: any;
  tExhaustB4: any;
  tExhaustB5: any;
  tExhaustB6: any;
  tExhaustB7: any;
  tExhaustB8: any;
  etcSpeedA1_2: any;
  etcSpeedA2_2: any;
  etcSpeedB1_2: any;
  etcSpeedB2_2: any;
  engineSpeed: any;
  fuelRackPosition: any;
  pLubeOilFilterDiff: any;
  pLubeOilETC: any;
  pControlAir: any;
  coolantLevel: any;
  motorStatus: any;
  colorStatus: any;
  colorSignalStatus: string[] = ['', '', '', ''];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  /**
   * Sets the active tab based on the tab selection event.
   * @param event the tab selection event
   * */
  public onTabChange(event) {
    this.activeTab = event.tabId;
  }

  protected mapContextData(context: any): void {

    this.positionEntity = context.position;
    this.shipEntity = context.ship;
    this.engineEntity = context.shipEngine;
    this.ambientEntity = context.shipAmbient;

    this.shipId = super.getValue(this.shipEntity, 'id');
    this.shipNo = 'TCG - ' + this.shipId.substring(this.shipId.lastIndexOf(':') + 1).replace('-', ' ');
    this.location = this.getSingleElementValue(this.positionEntity, 'location').coordinates.join(', ');
    this.relativeWindSpeed = super.getValue(this.ambientEntity, 'relativeWindSpeed');
    this.relativeWindDirection = super.getValue(this.ambientEntity, 'relativeWindDirection');
    this.cloudHeight = super.getValue(this.ambientEntity, 'cloudHeight');
    this.rainfallAmount = super.getValue(this.ambientEntity, 'rainfallAmount');
    this.seaWaterTemperature = super.getValue(this.ambientEntity, 'seaWaterTemperature');
    this.temperature = super.getValue(this.ambientEntity, 'temperature');
    this.humidity = super.getValue(this.ambientEntity, 'humidity');
    this.radiation = super.getValue(this.ambientEntity, 'radiation');
    this.currentDirection = super.getValue(this.ambientEntity, 'currentDirection');
    this.currentIntensity = super.getValue(this.ambientEntity, 'currentIntensity');
    this.swell = super.getValue(this.ambientEntity, 'swell');
    this.salinity = super.getValue(this.ambientEntity, 'salinity');
    this.distance = super.getValue(this.ambientEntity, 'distance');
    this.pressure = super.getValue(this.ambientEntity, 'pressure');
    this.heading = super.getValue(this.ambientEntity, 'heading');
    this.rateOfTurn = super.getValue(this.ambientEntity, 'rateOfTurn');
    this.courseOverGround = super.getValue(this.ambientEntity, 'courseOverGround');
    this.speedOverGround = super.getValue(this.ambientEntity, 'speedOverGround');
    this.speedThroughWater = super.getValue(this.ambientEntity, 'speedThroughWater');
    this.depth = super.getValue(this.ambientEntity, 'depth');
    this.heave = super.getValue(this.ambientEntity, 'heave');
    this.heaveRate = super.getValue(this.ambientEntity, 'heaveRate');
    this.roll = super.getValue(this.ambientEntity, 'roll');
    this.rollRate = super.getValue(this.ambientEntity, 'rollRate');
    this.status = super.getValue(this.ambientEntity, 'status');
    this.etcSpeedA1_1 = super.getValue(this.engineEntity, 'etcSpeedA1_1');
    this.etcSpeedA2_1 = super.getValue(this.engineEntity, 'etcSpeedA2_1');
    this.etcSpeedB1_1 = super.getValue(this.engineEntity, 'etcSpeedB1_1');
    this.etcSpeedB2_1 = super.getValue(this.engineEntity, 'etcSpeedB2_1');
    this.tLubeOil = super.getValue(this.engineEntity, 'tLubeOil');
    this.tFuel = super.getValue(this.engineEntity, 'tFuel');
    this.tCoolant = super.getValue(this.engineEntity, 'tCoolant');
    this.pCoolant = super.getValue(this.engineEntity, 'pCoolant');
    this.tExhaustA1 = super.getValue(this.engineEntity, 'tExhaustA1');
    this.tExhaustA2 = super.getValue(this.engineEntity, 'tExhaustA2');
    this.tExhaustA3 = super.getValue(this.engineEntity, 'tExhaustA3');
    this.tExhaustA4 = super.getValue(this.engineEntity, 'tExhaustA4');
    this.tExhaustA5 = super.getValue(this.engineEntity, 'tExhaustA5');
    this.tExhaustA6 = super.getValue(this.engineEntity, 'tExhaustA6');
    this.tExhaustA7 = super.getValue(this.engineEntity, 'tExhaustA7');
    this.tExhaustA8 = super.getValue(this.engineEntity, 'tExhaustA8');
    this.tExhaustB1 = super.getValue(this.engineEntity, 'tExhaustB1');
    this.tExhaustB2 = super.getValue(this.engineEntity, 'tExhaustB2');
    this.tExhaustB3 = super.getValue(this.engineEntity, 'tExhaustB3');
    this.tExhaustB4 = super.getValue(this.engineEntity, 'tExhaustB4');
    this.tExhaustB5 = super.getValue(this.engineEntity, 'tExhaustB5');
    this.tExhaustB6 = super.getValue(this.engineEntity, 'tExhaustB6');
    this.tExhaustB7 = super.getValue(this.engineEntity, 'tExhaustB7');
    this.tExhaustB8 = super.getValue(this.engineEntity, 'tExhaustB8');
    this.etcSpeedA1_2 = super.getValue(this.engineEntity, 'etcSpeedA1_2');
    this.etcSpeedA2_2 = super.getValue(this.engineEntity, 'etcSpeedA2_2');
    this.etcSpeedB1_2 = super.getValue(this.engineEntity, 'etcSpeedB1_2');
    this.etcSpeedB2_2 = super.getValue(this.engineEntity, 'etcSpeedB2_2');
    this.engineSpeed = super.getValue(this.engineEntity, 'engineSpeed');
    this.fuelRackPosition = super.getValue(this.engineEntity, 'fuelRackPosition');
    this.pLubeOilFilterDiff = super.getValue(this.engineEntity, 'pLubeOilFilterDiff');
    this.pLubeOilETC = super.getValue(this.engineEntity, 'pLubeOilETC');
    this.pControlAir = super.getValue(this.engineEntity, 'pControlAir');
    this.coolantLevel = super.getValue(this.engineEntity, 'coolantLevel');
    this.motorStatus = super.getValue(this.engineEntity, 'status');
    this.shipStatus = 'avaliable';
    this.colorStatus = '';
    this.status = this.getSingleElementValue(this.positionEntity, 'status');
    this.checkStatus();
    this.locationShip = this.formattedLocation(this.location);
    this.lastUpdatedTime = this.formatTimestamp(this.getSingleElementValue(this.positionEntity, 'status', 'observedAt'));
  }

   public convertToDMS(decimalDegrees) {
    const degrees = Math.floor(decimalDegrees);
    const decimalMinutes = (decimalDegrees - degrees) * 60;
    const minutes = Math.floor(decimalMinutes);
    const seconds = Math.round((decimalMinutes - minutes) * 60);

     return `${degrees}° ${minutes}' ${seconds}"`;
  }

  public formattedLocation(location) {
    const [lat, lon] = location.split(', ');
    const formattedLat = this.convertToDMS(parseFloat(lat).toFixed(3));
    const formattedLon =  this.convertToDMS(parseFloat(lon).toFixed(3));
    // return `Enlem: ${formattedLat}, Boylam: ${formattedLon}`;
    return [formattedLat, formattedLon];
  }

  public formatTimestamp(timestamp) {
    const date = new Date(timestamp);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day}.${month}.${year} ${hours}:${minutes}`;
  }

  getSingleElementValue(entity, field, valueField = 'value'): any {
    const elementValue = super.getValue(entity, field, valueField);
    if (Array.isArray(elementValue)) {
      return elementValue[0][valueField];
    } else {
      return elementValue;
    }
  }

  checkStatus() {
    if (this.status === '0') {
      this.shipStatus = 'avaliable';
      this.colorStatus = '';
      this.isRedImage = false;
      for (let i = 0; i < 4; i++) {
        this.colorSignalStatus[i] = '';
      }
    } else {
      this.shipStatus = 'error';
      this.colorStatus = '-red';
      this.isRedImage = true;

      if (this.status === '1') {
        this.colorSignalStatus[0] = '-red';
      } else if (this.status === '2') {
        this.colorSignalStatus[1] = '-red';
      } else if (this.status === '3') {
        this.colorSignalStatus[2] = '-red';
      } else if (this.status === '4') {
        this.colorSignalStatus[3] = '-red';
      }
    }
  }
}
